// extracted by mini-css-extract-plugin
module.exports = {"signinbutton":"signin_signinbutton__36dAw"};